import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import dataSourceIcon from "../../../assets/images/data-source-icon.svg";
import ErrorPopup from "../../../components/element/ErrorPopup";
import Loader from "../../../components/element/Loader";
import useAirlineAdminApi from "../../../services/api/useAirlineAdminApi";
import ROUTE_PATHS from "../../../utils/routePaths";
import "./AirlineList.css";
import CommercialAirlineNavigationBar from "../../../components/element/CommercialAirlineNavigationBar";

const AirlineList = () => {
  const navigate = useNavigate();
  const { fetchAviationStackAirlines } = useAirlineAdminApi();

  const {
    data: airlines,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["aviation-stack-airlines"],
    queryFn: () => fetchAviationStackAirlines(),
  });

  const handleAirlineClick = (airline) => {
    navigate(
      ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE_AVIATION_STACK_SUCCESS,
      {
        state: {
          airlineId: airline.id,
          airlineName: airline.airlineName,
        },
      }
    );
  };

  return (
    <div className="airline-list-container">
      <CommercialAirlineNavigationBar
        title={"Flight Data Success"}
        navigationLogo={dataSourceIcon}
        backContent={
          <div className="navigation-header">
            <Link
              to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
              className="navigation-header-link"
            >
              Home/
            </Link>
            <Link
              to={ROUTE_PATHS.COMMERCIAL_AIRLINE_DATA_SOURCE}
              className="navigation-header-link"
            >
              Data Source/
            </Link>
            Flight Data Success
          </div>
        }
      />
      <div className="airline-list-content">
        <div className="airline-table-wrapper">
          {isLoading ? (
            <div className="airline-list-loader-container">
              <Loader />
            </div>
          ) : error ? (
            <div className="airline-list-error-container">
              <ErrorPopup children={error.message} />
            </div>
          ) : (
            <table className="airline-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Airlines</th>
                </tr>
              </thead>
              <tbody>
                {airlines?.data?.map((airline, index) => (
                  <tr
                    key={airline.id}
                    onClick={() => handleAirlineClick(airline)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{index + 1}</td>
                    <td>{airline.airlineName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AirlineList;
